<section class="content">
  <div class="card" style="padding: 24px;">
    <div class="container-fluid">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <mat-label>Run Script For</mat-label>
          <!-- <mat-select [(ngModel)]="selected_day"  [(ngModel)]="show"  [disabled]="is_disabled" class="main-border-class">
            <mat-option *ngFor="let day of day_list" [value]="day" (click)="selectClicked()">{{day}}</mat-option>
          </mat-select> -->
          <div *ngIf="selected_day == 'Today'">
          <input type="text" class="main-border-class" value= 'Today' disabled>
          </div>

          <div *ngIf="selected_day != 'Today'">
            <input type="text" class="main-border-class" value= 'Tomorrow' disabled>
          </div>

          <br>
          <div class="row">
            <div class="col" *ngIf="selected_date !== null" style="font-size: 18px; color: blue; white-space: nowrap; margin-top: 17px; margin-left: 5px;">
              Upload For Date : {{ show_date | date: 'fullDate'}}
            </div>
          </div>
        </div>

        <div class="col-2">
          <button (click)="runClicked()"
            style="font-size: 27px;margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
            [disabled]=disable_run>Run</button>
        </div>
      </div>

    </div>
  </div>

  <div class="card" style="padding: 24px;" *ngIf="selected_date != null">
    <div class="container-fluid">
      <table  class="table table-bordered">
        <thead style="text-align: center;">
          <th><h2>Sl.No</h2></th>
          <th><h2>Script</h2></th>
          <th><h2>Run</h2></th>
          <th><h2>Progress</h2></th>
        </thead>
        <tbody>
          <tr *ngFor="let data of script_list; let data_index=index">
            <td><h3>{{data_index+1}}</h3></td>
            <td><h3>{{data.script}}</h3></td>
            <td style="text-align: center;">
              <button mat-button (click)="buttonClicked(data.script, data_index)" (click)="progressBarCalled(data, data_index)" [disabled]="data.is_compleated" [ngClass]="data.is_compleated ? 'disabled-button' : 'enabled-button'">Run</button>
            </td>
            <td>
              <div style="position: relative">
                <mat-progress-bar  mode="determinate" [value]="data.progress" color="primary" *ngIf="!data.process_compleated"></mat-progress-bar>
                <span style="position: absolute; top: 0.1em;font-size: 25px; margin-left: 175px; color: white;" [ngStyle]="{'center': data.progress + '%'}" *ngIf="!data.process_compleated">{{data.progress}}%</span>
              </div>
            </td>
          </tr>
          <!-- <tr *ngFor="let data of script_list; let data_index=index">
            <td>{{data['name']}}</td>
            <td><button [disabled]=data.is_compleated (click)="scriptRunCalled(data_index, data['name'])">Run</button></td>
          </tr> -->
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col" style="text-align: center;">
        <button mat-button [disabled]="is_completed" (click)="complete_clicked()" style="font-size: 27px;margin-top: 35px; margin-bottom: 23px; border-radius: 12px;" [ngClass]="is_completed ? 'disabled-complete-button' : 'enabled-complete-button'">
          Completed
        </button>
      </div>
    </div>
  </div>
</section>


